import { NameOnlyFileDataFragment } from '../api';

export const getExtension = (filename: string) => filename.split('.').pop();

export const isImageFile = (extension: string, allowedImageFileExtensions: string[]) =>
    (allowedImageFileExtensions ?? []).includes(extension.toLowerCase());

export const isDocFile = (extension: string, allowedDocFileExtensions: string[]) =>
    (allowedDocFileExtensions ?? []).includes(extension.toLowerCase());

export const diffUploads = (
    uploads: (NameOnlyFileDataFragment | File)[],
    initialUploads: NameOnlyFileDataFragment[]
) => {
    const newUploads: File[] = [];
    let removedUploads: NameOnlyFileDataFragment[] = [...initialUploads];

    uploads.forEach(upload => {
        if (upload instanceof File) {
            // add the new file
            newUploads.push(upload);
        } else {
            // this file is kept
            removedUploads = removedUploads.filter(item => upload.id !== item.id);
        }
    });

    return { newUploads, removedUploads };
};

export const getAcceptExtensions = (
    allowedExtensions: string[],
    allowedImageFileExtensions: string[],
    allowedDocFileExtensions: string[]
) =>
    allowedExtensions.map(extension => {
        if (isImageFile(extension, allowedImageFileExtensions ?? [])) {
            return `image/${extension}`;
        }

        if (isDocFile(extension, allowedDocFileExtensions ?? [])) {
            return `application/${extension}`;
        }

        return extension;
    });
